import axios from "axios";
import router from "../router";
import Vue from "vue";

export default () => {
  const axiosInstance = axios.create({
    baseURL: `${process.env.VUE_APP_BASE_URL}/api`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  Vue.prototype.$http = axiosInstance;
  Vue.config.productionTip = false;
  axiosInstance.defaults.timeout = 1000000 ;

  axiosInstance.interceptors.request.use(
    (config) => {
      const user = JSON.parse(localStorage.getItem("user"));
      const token = user.data.access_token;
      if (token) {
        config.headers.common["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.status === 200 || response.status === 201) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    },
    (error) => {
      if (error&&error.response&&error.response.status) {
        switch (error.response.status) {
          case 400:
            //do something
            break;
          case 401:
            localStorage.clear();
            router.push("/login");
            break;
          case 403:
            router.replace({
              path: "/login",
              query: { redirect: router.currentRoute.fullPath },
            });
            break;
          case 404:
            alert("page not exist");
            break;
          case 502:
            setTimeout(() => {
              router.replace({
                path: "/login",
              });
            }, 1000);
            break;
            default:
            "It does not have HTTP ok status"
        }
        return Promise.reject(error.response);
      }
    }
  );
  return axiosInstance;
};
